import { useQuery } from "react-query";
import { getDigitalAssetsReport } from "../../../../../actions/DigitalAssets";

const useGetDigitalAssetsReport = () => {
  return useQuery("GetDigitalAssetsReport", getDigitalAssetsReport, {
    refetchOnWindowFocus: false,
  });
};
export default useGetDigitalAssetsReport;
